angular.module('tgaAdmin').directive('interstitialScale', [
  '$window',
  function ($window) {
    return {
      restrict: 'A',
      link($scope, $element) {
        const e = $element[0];
        const zoomScaleMax = 0.425;
        function onWindowResizeInterstitial() {
          let scale = zoomScaleMax;
          const parent = e.closest('[name=gameForm]');
          if (angular.isUndefined(parent) || parent === null) {
            return;
          }
          const parentWidth = parent.clientWidth - 132;
          const proposedScale = (parentWidth / 1920);
          if (proposedScale < zoomScaleMax) {
            scale = proposedScale;
          }
          e.style.width = `${Math.floor(1920 * scale)}px`;
          e.style.height = `${Math.floor(1080 * scale)}px`;
          e.children[0].style.transform = `scale(${scale})`;
          e.children[0].style.transformOrigin = 'top left';
        }
        $window.addEventListener('resize', onWindowResizeInterstitial);
        $scope.$on('tabChanged', onWindowResizeInterstitial);
        onWindowResizeInterstitial();
        $scope.$on('$destroy', () => {
          $window.removeEventListener('resize', onWindowResizeInterstitial);
        });
      },
    };
  }]);
